/*
===============================================================
  ____    ___    ____   _   __       __                
 |  _ |  / _ \  |  _ \ | | |   \    |   \  ___  __ __  
 |  __| | |_| | |  __/ | | | |) | o | |) |/ -_) \ V /  
 |_|\_\ |_| |_| |_|    |_| |___/    |___/ \___|  \_/    o o o   

===============================================================
*/

import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Autocomplete from "@mui/material/Autocomplete";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";

function ProfileInfo({ attr, setAttr }) {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    setAttr(attr);
  }, [attr]);

  return (
    <MDBox p={3}>
      <MDTypography variant="h5">Profile</MDTypography>
      <MDBox mt={1}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12}>
            <MDInput
              success
              label={t(`attr.email`)}
              value={attr.email}
              variant="standard"
              inputProps={{
                disabled: true,
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <MDInput
              label={t(`attr.firstname`)}
              onChange={(e) => setAttr({ ...attr, name: e.target.value })}
              value={attr.name}
              variant="standard"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <MDInput
              label={t(`attr.tel`)}
              onChange={(e) => setAttr({ ...attr, phone_no: e.target.value })}
              value={attr.phone_no || ""}
              variant="standard"
              fullWidth
            />
          </Grid>
        </Grid>
      </MDBox>
    </MDBox>
  );
}

ProfileInfo.propTypes = {
  attr: PropTypes.shape({
    name: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    phone_no: PropTypes.string.isRequired,
    language: PropTypes.string.isRequired,
  }).isRequired,
  setAttr: PropTypes.func.isRequired,
};

export default ProfileInfo;
